import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {ProductService}
 */
export default class ProductService{

    constructor() {
        this.resource = "/product"

        this.http = Rest.build(store.getters.token  , this.resource);
    }

    static build() {
        return new this();
    }

    get_all(item){
        var parameters = new URLSearchParams(item);
       
        parameters = parameters.toString();
        if(parameters){
            parameters = "?"+parameters;
        }
        return this.http.get(`/all${parameters}`);
    }

    get_one(product_id){
        return this.http.get(`/${product_id}`)    
    }

    /**
     * Salva metadados do vídeos 
     */
    saveMetadata(params){
        return this.http.post('/save', params)
    }

    /**
     * Muda o status do Produto
     */
    set_approved(_product_id){
        return this.http.post('/set_approved', {product_id:_product_id});
    }

     /**
     * Muda o status do Produto
     */
    set_editable(_product_id,n_status='editable'){
        return this.http.post('/change_status', {product_id:_product_id, status:n_status});
    }


     /**
     * Muda o status do Produto
     */
    set_underanalisys(_product_id){
        return this.http.post('/change_status', {product_id:_product_id,status:'underanalysis'});
    }

    /*sendAudioFile(params, http_options){
        var form_data = new FormData();
        for ( var key in params ) {
            form_data.append(key, params[key]);
        }
        return this.http.postFormData('/save/audio', form_data, http_options)
    }

    sendCover(params){
        var form_data = new FormData();
        for ( var key in params ) {
        form_data.append(key, params[key]);
        }
        return this.http.post('/save/cover', form_data)
    }*/


}